import { useTranslations } from 'next-intl';
import { IBreadcrumb } from '@monofront/types';
import { useAuthentication } from '@context/businessContainer';
import Breadcrumb from '@components/Breadcrumb';

interface IProductBreadcrumbProps {
  breadcrumb?: IBreadcrumb[];
  title: string;
}

/* @TODOFP use for e2e tests
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"},{"handle":"compotes-et-desserts-vegetaux-bio","omsId":"1374","title":"Compotes et Desserts Végétaux Bio"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"},{"handle":"compotes-et-desserts-vegetaux-bio","omsId":"1374","title":"Compotes et Desserts Végétaux Bio"},{"handle":"compote-bio","omsId":"2457","title":"Compote bio"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"},{"handle":"compotes-et-desserts-vegetaux-bio","omsId":"1374","title":"Compotes et Desserts Végétaux Bio"},{"handle":"compote-bio","omsId":"2457","title":"Compote bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes en bocaux Bio"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"},{"handle":"compotes-et-desserts-vegetaux-bio","omsId":"1374","title":"Compotes et Desserts Végétaux Bio"},{"handle":"compote-bio","omsId":"2457","title":"Compote bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes en bocaux Bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes au pommes en bocaux Bio"}];
  // breadcrumb = [{"handle":"all","omsId":"1461","title":"Notre sélection"},{"handle":"epicerie-sucree-bio","omsId":"861","title":"Epicerie sucrée"},{"handle":"compotes-et-desserts-vegetaux-bio","omsId":"1374","title":"Compotes et Desserts Végétaux Bio"},{"handle":"compote-bio","omsId":"2457","title":"Compote bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes en bocaux Bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes au pommes en bocaux Bio"},{"handle":"compotes-en-bocaux","omsId":"1206","title":"Compotes au pommes cuites en bocaux Bio"}];
  // a => a
  // a / b => a / b
  // a / b / c => b / c
  // a / b / c / d => c / d
  // a / b / c / d / e => c / e
  // a / b / c / d / e / f => c / f
  // a / b / c / d / e / f / g => c / g
  */

const ProductBreadcrumb: React.FC<IProductBreadcrumbProps> = ({
  breadcrumb,
  title,
}) => {
  const { isAuthenticated } = useAuthentication();
  const tGlobal = useTranslations('Global');
  const [, ...breadcrumbsWithoutFirst] = breadcrumb || [];

  return (
    <Breadcrumb>
      <Breadcrumb.Link isHiddenOnMobile href={isAuthenticated ? '/home' : '/'}>
        {tGlobal('home')}
      </Breadcrumb.Link>
      {breadcrumbsWithoutFirst?.map((link, index) => {
        // show 3rd and last collection levels on mobile, otherwise show the last 2 collection levels.
        const isShownOnMobile =
          breadcrumbsWithoutFirst.length < 5
            ? index === breadcrumbsWithoutFirst.length - 1 ||
              index === breadcrumbsWithoutFirst.length - 2
            : index === 2 || index === breadcrumbsWithoutFirst.length - 1;

        return (
          <Breadcrumb.Link
            key={link.omsId}
            href={`/collections/${link.handle}`}
            isHiddenOnMobile={!isShownOnMobile}
          >
            {link.title}
          </Breadcrumb.Link>
        );
      })}
      <Breadcrumb.Link isHiddenOnMobile isCurrentPage>
        {title}
      </Breadcrumb.Link>
    </Breadcrumb>
  );
};

export default ProductBreadcrumb;
